import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';

@Injectable({
  providedIn: 'root',
})
export class RSAHelper {
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJEf6UHD17nUK69u+ojJ7xRFXy
  sqvABnsC8EqaVaaPgewEFsJ41SVx74mzRIlsrEttvD2KMx5oMQ3O20nsu5v7hjlB
  1cbeUCPif+/ivfHGNc8aQ/AhbTSj0bC0M0g0kVedzlOuPurpScimZ41khqZgr03U
  sk4xLl2LHWMlue0V/wIDAQAB
  -----END PUBLIC KEY-----`;

  constructor() {}

  encryptWithPublicKey(valueToEncrypt: string): string {
    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }

  decryptWithPrivateKey(valueToDecrypt: string, privateKey: string): string {
    const rsa = Forge.pki.privateKeyFromPem(privateKey);
    const decrypted = rsa.decrypt(window.atob(valueToDecrypt));
    return decrypted.replaceAll('\0', '');
  }
}
